import { DateFormatEnum, TimeFormatEnum } from 'shared/enums/date-time-format-enum'
import { dateFormat, timeFormat } from 'shared/utils/date-time-format'

export const DateFormatCaptions = {
  [DateFormatEnum.dateFirst]: 'Day/Month/Year',
  [DateFormatEnum.monthFirst]: 'Month/Day/Year',
}

export const TimeFormatCaptions = {
  [TimeFormatEnum.hourMinute]: 'Hour:Minute',
  [TimeFormatEnum.hourMinuteAmPm]: 'Hour:Minute AM/PM',
  [TimeFormatEnum.hourMinuteSecond]: 'Hour:Minute:Seconds',
  [TimeFormatEnum.hourMinuteSecondAmPm]: 'Hour:Minute:Seconds AM/PM',
}

export function getTimezonesDataOptions(timezones: Record<string, string>) {
  return Object.entries(timezones).map(([timezoneKey, timezoneLabel]) => {
    return {
      id: timezoneKey,
      caption: timezoneLabel,
    }
  })
}

export function getFormatDataOptions(timeZone?: string) {
  return (Object.keys(DateFormatEnum) as Array<keyof typeof DateFormatEnum>).map(formatKey => {
    return {
      id: DateFormatEnum[formatKey],
      caption: `${DateFormatCaptions[DateFormatEnum[formatKey]]} - ${dateFormat(new Date(), {
        dateFormat: DateFormatEnum[formatKey],
        timeZone: timeZone,
      })}`,
    }
  })
}

export function getFormatTimeOptions(timeZone?: string) {
  return (Object.keys(TimeFormatEnum) as Array<keyof typeof TimeFormatEnum>).map(formatValue => {
    return {
      id: TimeFormatEnum[formatValue],
      caption: `${TimeFormatCaptions[TimeFormatEnum[formatValue]]} - ${timeFormat(new Date(), {
        timeFormat: TimeFormatEnum[formatValue],
        timeZone: timeZone,
      })}`,
    }
  })
}
